import React from 'react';
import AdminFeedbackManagement from '../../components/admin/AdminFeedbackManagement';

const AdminFeedback = () => {
    return <AdminFeedbackManagement />;
};

export default AdminFeedback;
